import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { SubmitButton } from "../../../components/common/form/SubmitButton";
import { useSubmitAction } from "../../../components/common/form/useSubmitAction";
import { MaterialUITableDataItem } from "./types";

const noAction = () => {};

interface MaterialUITableProps {
  data: MaterialUITableDataItem[];
  insideForm?: boolean | false;
  submitMethod?: any;
}

export const MaterialUITable2 = ({ data, insideForm = false, submitMethod }: MaterialUITableProps) => {
  // Extract column headers dynamically
  const columns: string[] = data.length > 0 ? Object.keys(data[0]) : [];
  // double-click guard: Submit is disabled with a spinner until submitMethod finishes
  const { run, submitting } = useSubmitAction(submitMethod ?? noAction);

  return (
    <Box >
      <form onSubmit={submitMethod ? run : undefined}>
        <TableContainer className="mui-table-container-style">
          <Table size="small" className="mui-table-bordered">
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={col} >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, rowIndex) => (
                <TableRow key={rowIndex} >
                  {columns.map((col) => (
                    <TableCell key={col} >
                      {row[col]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {insideForm ? (
          <Box sx={{ textAlign: "center", margin: "10px" }}>
            <SubmitButton submitting={submitting} color="primary" size="small" />
          </Box>
        ) : (
          ""
        )}
      </form>
    </Box>
  );
};
